import { render, staticRenderFns } from "./BaseTextBoxWithLabel.vue?vue&type=template&id=84e3d234&scoped=true"
import script from "./BaseTextBoxWithLabel.vue?vue&type=script&lang=ts"
export * from "./BaseTextBoxWithLabel.vue?vue&type=script&lang=ts"
import style0 from "./BaseTextBoxWithLabel.vue?vue&type=style&index=0&id=84e3d234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e3d234",
  null
  
)

export default component.exports